import { type SupportedLocale } from '@zep-us/i18n';

import { type ProcessedQuizItem } from '../../type';

/**
 * 번역 기능에서만 추가로 지원하는 언어
 * (일반 SupportedLocale에는 없음)
 */
export const TRANSLATION_ONLY_LANGUAGES = [
  'kk', // 카자흐어
  'mn', // 몽골어
  'uk', // 우크라이나어
  'ne', // 네팔어
  'my', // 미얀마어
  'bn', // 방글라데시어
  'ur', // 우르두어
] as const;

export type TranslationOnlyLanguage =
  (typeof TRANSLATION_ONLY_LANGUAGES)[number];

/**
 * @see https://zep-us.slack.com/archives/C07374E939S/p1751249555735269
 */
export const SUPPORTED_TRANSLATION_LANGUAGES = [
  'ko',
  'en',
  'vi',
  'zh-CN',
  'zh-TW',
  'fil',
  'km',
  'uz',
  'kk', // 번역 전용
  'ja',
  'mn', // 번역 전용
  'ru',
  'uk', // 번역 전용
  'th',
  'fr',
  'es',
  'id',
  'ne', // 번역 전용
  'my', // 번역 전용
  'bn', // 번역 전용
  'ur', // 번역 전용
  'ms',
  // 신규 추가 언어 (PR #80)
  'en-SG',
  'pt-BR',
  'hi-IN',
  'bn-IN',
  'pa-IN',
  'ta-IN',
  'te-IN',
  'ml-IN',
  'et',
  'zh-HK',
] as const;

export type SupportedTranslationLanguage =
  | SupportedLocale
  | TranslationOnlyLanguage;

export type TranslationData = {
  [k in SupportedTranslationLanguage]?: ProcessedQuizItem[];
};
